// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KEyQdYE66h0RvLBQ{margin:0 auto;max-width:288px}.KEyQdYE66h0RvLBQ .MTWdqpSH4Dc1VVCC{margin-top:16px}.KEyQdYE66h0RvLBQ .MTWdqpSH4Dc1VVCC:first-child{margin-top:0}.KEyQdYE66h0RvLBQ .MTWdqpSH4Dc1VVCC .bLeJSqLmoA32eefT{margin-top:8px}.eXpgddyo1Q4B21ds{margin:0 auto;max-width:150px}.eXpgddyo1Q4B21ds .U47I0VnUBjsw5YXC{width:100%;min-width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formWrapper": `KEyQdYE66h0RvLBQ`,
	"inputGroup": `MTWdqpSH4Dc1VVCC`,
	"input": `bLeJSqLmoA32eefT`,
	"buttonWrapper": `eXpgddyo1Q4B21ds`,
	"button": `U47I0VnUBjsw5YXC`
};
export default ___CSS_LOADER_EXPORT___;
